export const FILTERS = [{
  label: 'None',
  value: {
    filter: null,
    overlayColor: null
  }
}, {
  label: 'Dark',
  value: {
    filter: 'dark',
    overlayColor: null
  }
}, {
  label: 'Light',
  value: {
    filter: 'light',
    overlayColor: null
  }
}, {
  label: 'Dots',
  value: {
    filter: 'dots',
    overlayColor: {
      r: '0',
      g: '0',
      b: '0',
      a: '0.5'
    }
  }
}, {
  label: 'Lines',
  value: {
    filter: 'lines',
    overlayColor: {
      r: '0',
      g: '0',
      b: '0',
      a: '0.5'
    }
  }
}, {
  label: 'Stripes',
  value: {
    filter: 'stripes',
    overlayColor: {
      r: '0',
      g: '0',
      b: '0',
      a: '0.5'
    }
  }
}, {
  label: 'Gradient Top',
  value: {
    filter: 'gradientTop',
    overlayColor: {
      r: '0',
      g: '0',
      b: '0',
      a: '1'
    }
  }
}, {
  label: 'Gradient Bottom',
  value: {
    filter: 'gradientBottom',
    overlayColor: {
      r: '0',
      g: '0',
      b: '0',
      a: '1'
    }
  }
}, {
  label: 'Dark Overlay',
  value: {
    filter: 'darkOverlay',
    overlayColor: null
  }
}, {
  label: 'White Overlay',
  value: {
    filter: 'whiteOverlay',
    overlayColor: null
  }
}, {
  label: 'Frosted',
  value: {
    filter: 'frosted',
    overlayColor: null
  }
}];

export const POSITIONS = [{
  value: 'top left'
}, {
  value: 'top center'
}, {
  value: 'top right'
}, {
  value: 'center left'
}, {
  value: 'center center'
}, {
  value: 'center right'
}, {
  value: 'bottom left'
}, {
  value: 'bottom center'
}, {
  value: 'bottom right'
}];